export const strainReview = (strainId: string, reviewId?: string): string =>
  `/strains/${strainId}/reviews/${reviewId || ""}`;
